import { api } from '@/scripts/api';

export const SocialMediaNetworkService = {

    get(clientId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialnetwork/${clientId}`;

            api.get(service)
                .then(resolve)
                .catch(reject);
        });
    },

    getAccounts(clientId, config = {}) {
        return new Promise((resolve, reject) => {
            const service  = `/ms/socialmedia/v1/socialnetwork/accounts/${clientId}`;
            const endpoint = api.applyNodeDataParams(service, config);

            api.get(endpoint)
                .then(resolve)
                .catch(reject);
        });
    },

    delete(id, clientId){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialnetwork/accounts/${id}/${clientId}`;

            api.delete(service)
                .then(resolve)
                .catch(reject);
        })
    },

    put(id, clientId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialnetwork/accounts/${id}/${clientId}`;
            
            api.put(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },

}
